<template>
  <span class="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-blue-50 text-blue-700 text-xs">
    <Globe class="w-3 h-3" />
    Remote
  </span>
</template>

<script setup lang="ts">
import { Globe } from 'lucide-vue-next'
</script> 